import React, { useEffect } from 'react';
import { Loader } from 'ui';
import seoConfig from '../seo.json';
import Seo from 'src/components/Seo';
import { useGetMyChallenges } from 'src/hooks/prepPlan.hooks';
import NoChallengesFound from 'src/components/challenges/NoChallengesFound';
import ChallengesContainer from 'src/components/challenges/ChallengesContainer';
import classNames from 'classnames';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
interface Props {
	fromDashboard?: boolean;
}
const MyChallenges = ({ fromDashboard }: Props) => {
	const { data, isLoading, isError, refetch } = useGetMyChallenges();
	const seoInfo = seoConfig['challenges'];

	useEffect(() => {
		refetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (isLoading) {
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
		);
	}

	if (isError) {
		// render error screen
	}

	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<div>
				<div className={fromDashboard ? '' : 'container mx-auto m-auto w-full px-[16px] xl:px-[80px] max-w-[1440px]'}>
					{data?.challenges && data.challenges.length ? (
						<ChallengesContainer fromDashboard={fromDashboard} challenges={data.challenges} />
					) : (
						<div
							className={classNames(
								'sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center',
								fromDashboard ? 'h-[calc(50vh-70px)]' : 'h-[calc(90vh-70px)] ',
							)}
						>
							<NoChallengesFound />
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default MyChallenges;
